



























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-radio',

})
export default class IRadio extends Vue {

  @Prop({type: [Boolean], default: false}) protected isCheck!: boolean

}

